// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__OhAGL","emails":"CreateEditClinics_emails__1kFC-","emailTagLabel":"CreateEditClinics_emailTagLabel__1LQa0"};